module.exports = __webpack_public_path__ + "img/water-meter-128x128-transp.82cbb663.png";